import { SettingsService } from '../services/settings.service';

export function confirmRemove(message: string): boolean {
  if (SettingsService.instance.skipRemoveConfirmDialogs()) {
    return true;
  }
  return confirm(message);
}
